export const H2 = {
  fontSize: {
    xs: '26px',
    md: '32px',
    lg: '38px',
    xl: '42px'
  },
  lineHeight: {
    xs: '34px',
    md: '38px',
    lg: '46px',
    xl: '54px'
  }
};